export class MultiRenderData {
    constructor() {
        this.renderData = [];
        this.id = MultiRenderData.ID++;
    }
    addData(textureName, blendMode, offset, length, attachment) {
        this.currentData = { textureName: textureName, blendMode, offset, length, attachment };
        this.renderData.push(this.currentData);
    }
    endData(length) {
        this.currentData.length = length - this.currentData.offset;
    }
}
MultiRenderData.ID = 0;
